








import Vue from 'vue';

export default Vue.extend({
  name: 'icon-logout',
  props: {
    color: {
      type: String,
      required: false,
      default: '#FFFFFF',
    },
  },
});
